export const GOBOLT_SUPPORT_EMAIL = "hello@gobolt.com";
